import { render, staticRenderFns } from "./SpecimensMainPage.vue?vue&type=template&id=ebaccd40"
import script from "./SpecimensMainPage.vue?vue&type=script&lang=js"
export * from "./SpecimensMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports